/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import { useState } from 'react'
import "./Navbar.css"
import images from '../../Asset/Img/img'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';



function Navbar({ location }) {

  const pruductIcon = <FontAwesomeIcon icon={faCaretUp} />

  const [isCheked, setIsChecked] = useState(false)
  function dropClick(dropEvent) {
    document.addEventListener('click', (windowEvent) => {
      if (dropEvent.target.className === windowEvent.target.className) {
        setIsChecked(!isCheked)
      } else {
        setIsChecked(false)
      }
    })
    document.addEventListener('scroll', () => {
      setIsChecked(false)
    })
  }

  return (

    <div className={`${!isCheked ? 'navbar-container' : 'navbar-container-active'}`}>
      <div className='navbar-content'>

        <div className='logo-container'>
          <img src={location === "/" ? images.logoWhite : images.logo} alt="logo" />
        </div>


        <div className={`${!isCheked ? 'nav-drop-icon-container' : 'nav-drop-icon-container-active'}`} onClick={(dropEvent) => dropClick(dropEvent)}>

          <div className={`${!isCheked ? 'icon-item icon-up' : 'icon-up-active'}`}></div>

          <div className={`${!isCheked ? 'icon-item icon-short' : 'icon-short-active'}`}></div>

          <div className={`${!isCheked ? 'icon-item icon-down' : 'icon-down-active'}`}></div>

        </div>



        <ul className={`${!isCheked ? 'link-container' : 'link-container-active'}`} >
          <li><NavLink to='/' style={location === "/" ? { color: "white" } : { color: "" }}>ANA SAYFA</NavLink></li>
          <li><NavLink to='/about' style={location === "/" ? { color: "white" } : { color: "" }}>HAKKIMIZDA</NavLink></li>
          <li className='pruducts-container'>
            <a className="pruduct-link" style={location === "/" ? { color: "white" } : { color: "" }}>ÜRÜNLER</a>
            <div className='pruducts-dropdown'>
              {pruductIcon}
              <ul className='pruducts-links'>
                <li> <NavLink to='/sealing'>SIZDIRMAZLIK ÜRÜNLERİ TEKNOLOJİSİ</NavLink> </li>
                <li> <NavLink to='/vibration'>TİTREŞİM ÖNLEME TEKNOLOJİLERİ</NavLink> </li>
                <li> <NavLink to='/drinkwater'>İÇME SUYU</NavLink> </li>
                <li> <NavLink to='/'>YANMAZ HAMUR</NavLink> </li>
                <li> <NavLink to='/special'>ÖZEL VE İHTİYACA YÖNELİK</NavLink> </li>
              </ul>
            </div>
          </li>

          <li ><NavLink to='/packaging' style={location === "/" ? { color: "white" } : { color: "" }}>PAKETLEME</NavLink></li>

          <li className='pruducts-container'>
            <a className="pruduct-link" style={location === "/" ? { color: "white" } : { color: "" }}>TEKNOLOJİMİZ</a>
            <div className='pruducts-dropdown'>
              {pruductIcon}
              <ul className='pruducts-links'>
                <li> <NavLink to='/mixingprocess'>Karışım Prosesi</NavLink> </li>
                <li> <NavLink to='/material'>Malzeme Geliştirme</NavLink> </li>
                <li> <NavLink to='/'>Otomasyon</NavLink> </li>
              </ul>
            </div>

          </li>
          <li className='pruducts-container'>
            <a className="pruduct-link" style={location === "/" ? { color: "white" } : { color: "" }}>KALİTE</a>
            <div className='pruducts-dropdown'>
              {pruductIcon}
              <ul className='pruducts-links'>
                <li> <NavLink to='/qualitycontrol'>Kalite Kontrol Ve Test</NavLink> </li>
                <li> <NavLink to='/qualitassurance'>Kalite Güvence (ISO 9001)</NavLink> </li>
              </ul>
            </div>
          </li>
          <li><NavLink to='/' style={location === "/" ? { color: "white" } : { color: "" }}>SÜRDÜRÜLEBİLİRLİK</NavLink></li>
          <li><NavLink to='/contact' style={location === "/" ? { color: "white" } : { color: "" }}>İLETİŞİM</NavLink></li>
          <div className='language-btn'>
            <button className='tr'>TR</button>
            <button className='en'>EN</button>
          </div>

        </ul>


      </div>
    </div>

  )
}

export default Navbar
